/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
import * as React from 'react';
import { StatusMessage } from '../StatusMessage/index.js';
import { InputContainer, useSafeContext } from '../utils/index.js';
import { ComboBoxStateContext } from './helpers.js';
export const ComboBoxInputContainer = (props) => {
    const { className, status, message, children, ...rest } = props;
    const { id } = useSafeContext(ComboBoxStateContext);
    return (React.createElement(InputContainer, { className: className, status: status, statusMessage: typeof message === 'string' ? (React.createElement(StatusMessage, { status: status }, message)) : (React.isValidElement(message) &&
            React.cloneElement(message, { status })), ...rest, id: id },
        React.createElement("div", { className: 'iui-input-with-icon' }, children)));
};
ComboBoxInputContainer.displayName = 'ComboBoxInputContainer';
